import { type Rate } from "./rate";

abstract class WithRates {
  protected readonly rates: readonly Rate[];

  protected constructor(rates: Rate[]) {
    this.rates = rates.sort((a, b) => a.compareWith(b));
  }

  abstract isNumbered(): boolean;

  abstract getName(): string;

  getUniqueRate() {
    const availableRates = this.rates.filter((rate) => rate.isAvailable());

    return (availableRates.length === 1 ? availableRates[0] : null) ?? null;
  }

  findRate(rateId: number) {
    return this.rates.find((rate) => rate.getId() === rateId);
  }

  getRate(rateId: number) {
    const rate = this.findRate(rateId);

    if (!rate) {
      throw new Error(`Rate ${rateId} not found`);
    }

    return rate;
  }

  getRates() {
    return [...this.rates];
  }

  filterByName(name: string) {
    return this.rates.filter((rate) => rate.isAvailable() && (name === "" || rate.matchName(name)));
  }

  getMinRate() {
    return this.rates.reduce((aRate, anotherRate) =>
      aRate.getTotalPrice() < anotherRate.getTotalPrice() ? aRate : anotherRate,
    );
  }

  hasAnyRateAvailable() {
    return this.rates.some((rate) => rate.isAvailable());
  }
}

export { WithRates };
